@defer (when ready()) {
  <div class="main-content-fade">
    <app-header></app-header>
    <app-sidebar></app-sidebar>

    <div class="content-wrapper">
      <div class="container-fluid">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
}
